(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function () {
  function loadImages(section) {
    if (window.theme && window.theme.ProductBlockManager &&
        typeof window.theme.ProductBlockManager.loadImages === 'function') {
      window.theme.ProductBlockManager.loadImages(section);
    }
  }
  function initializeRecommendations(root) {
    var customSections = root.querySelectorAll('[data-tag-product-recommendations]');
    for (var i = 0; i < customSections.length; i++) loadImages(customSections[i]);
    var autoSections = root.querySelectorAll('[data-auto-product-recommendations]');
    for (var j = 0; j < autoSections.length; j++) loadAutomatic(autoSections[j]);
  }
  function loadAutomatic(section) {
    if (section.dataset.loaded === 'true') { loadImages(section); return; }
    if (section.dataset.loading === 'true') return;
    section.dataset.loading = 'true';
    var url = section.dataset.url + '?section_id=' + encodeURIComponent(section.dataset.sectionId) +
      '&limit=' + encodeURIComponent(section.dataset.limit) +
      '&product_id=' + encodeURIComponent(section.dataset.productId);
    var request = new XMLHttpRequest();
    request.open('GET', url);
    request.onload = function () {
      section.dataset.loading = 'false';
      if (request.status < 200 || request.status >= 300) return;
      var container = document.createElement('div');
      container.innerHTML = request.responseText;
      var result = container.querySelector('[data-auto-product-recommendations]');
      if (!result || !document.documentElement.contains(section)) return;
      section.innerHTML = result.innerHTML;
      section.dataset.loaded = 'true';
      loadImages(section);
    };
    request.onerror = request.ontimeout = function () { section.dataset.loading = 'false'; };
    request.timeout = 15000;
    request.send();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeRecommendations(document); });
  } else {
    initializeRecommendations(document);
  }
  window.addEventListener('load', function () { initializeRecommendations(document); });
  document.addEventListener('shopify:section:load', function (event) {
    initializeRecommendations(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
